"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerScoreCard = void 0;
const react_1 = __importDefault(require("react"));
require("./PlayerScoreCard.scss");
const PlayerScoreCard_scss_json_1 = __importDefault(require("./PlayerScoreCard.scss.json"));
const package_1 = require("../../package");
const TopicScore_1 = require("../../shapes/TopicScore");
const react_2 = require("@tolgee/react");
const medal_1 = require("../../utils/medal");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
exports.PlayerScoreCard = (0, package_1.linkedComponent)(TopicScore_1.TopicScore.request((t) => ({
    identifier: t.topic.identifier,
    topicName: t.topic.name,
    medal: t.medal,
    points: t.score,
})), ({ linkedData: { identifier, topicName, medal, points } }) => {
    let { t } = (0, react_2.useTranslate)();
    let image;
    if ((0, medal_1.getMedalType)(medal) === 'bronze' ||
        (0, medal_1.getMedalType)(medal) === 'silver' ||
        (0, medal_1.getMedalType)(medal) === 'gold') {
        image = `/images/medals/${topicName.toLowerCase()}-${(0, medal_1.getMedalType)(medal)}.webp`;
    }
    else {
        image = '/images/Fire_Orange.gif';
    }
    return (react_1.default.createElement("div", { className: PlayerScoreCard_scss_json_1.default.PlayerScoreCard },
        react_1.default.createElement("div", { className: PlayerScoreCard_scss_json_1.default.text },
            react_1.default.createElement("p", null, t('word.action', 'Action') + ' ' + identifier),
            react_1.default.createElement("h2", null, topicName)),
        react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)(image), className: PlayerScoreCard_scss_json_1.default.image }),
        react_1.default.createElement("p", null,
            points,
            ' ',
            points === 1
                ? t('word.action', 'action')
                : t('word.actions', 'actions'))));
});
//# sourceMappingURL=PlayerScoreCard.js.map